import { Component, OnInit, Inject } from '@angular/core';
import { IssueInfo } from '../model/issue.model';
import { ProjectInfo } from '../model/project.model';
import { EmpInfo } from '../model/emp.model';
import { TeamInfo } from '../model/team.model';
import { LookupInfo } from '../model/lookup.model';
import { RoleInfo } from '../model/role.model';
import { JobInfo } from '../model/Job.model';

import {
  HttpClient,
  HttpHeaders
} from "@angular/common/http";
import {
  environment
} from 'src/environments/environment';
import { CompanyInfo } from '../model/company.model';
import { ActivatedRoute } from '@angular/router';
import { TokenService } from '../service/token.service';
import { Observable } from 'rxjs';
import { GlobalService } from '../service/global.service';
import { PositionLevelInfo } from '../model/PositionManagementInfo.model';
import { CompetenceSkillInfo } from '../model/CompetenceSkillInfo.model';
import { EmployeeCompetenceSkillInfo } from '../model/EmployeeCompetenceSkillInfo.model';

@Component({
  selector: 'app-user-management',
  templateUrl: './user-management.component.html',
  styleUrls: ['./user-management.component.css']
})
export class UserManagementComponent implements OnInit {

  EmpOnPromise: Promise<EmpInfo[]>
  empList: EmpInfo[] = [];

  LookupPromise: Promise<LookupInfo[]>
  TitleList: LookupInfo[] = [];
  PositionList: PositionLevelInfo[] = [];
  EmpTypeList: LookupInfo[] = [];
  TeamList: TeamInfo[] = [];
  RoleList: RoleInfo[] = [];
  CompanyList: CompanyInfo[] = [];
  GenderList: LookupInfo[] = [];
  BaseAreaList: LookupInfo[] = [];
  JobTitleList: JobInfo[] = [];
  SubRoleList: LookupInfo[] = [];
  CompetenceSkillList: CompetenceSkillInfo[] = [];
  SkillLevelList: LookupInfo[] = [];
  SelectedEmpCompetenceSkillList: EmployeeCompetenceSkillInfo[] = [];

  isSearchSubmitted: boolean = false
  txtSearchEmpCode: string
  txtSearchEmpName_TH: string
  txtSearchCompany: string

  txtEmpCode: string
  txtExEmpCode: string
  txtEmpEmail: string
  hidTitleCode: string
  txtEmpNickName_TH: string
  txtEmpFName_TH: string
  txtEmpLName_TH: string
  txtEmpFName_EN: string
  txtEmpLName_EN: string
  hidPositionCode: number
  hidEmpType: string
  hidTeamCode: string
  hidRoleCode: string
  ddlCompany: string = null
  hidEmpId: number
  ddlEmpGender: string = ""
  ddlBaseArea: string = ""
  ddlJobTitle: string = ""
  ddlSubRole: string = ""
  birthDate: string
  entryDate: string
  resignDate: string = null
  txtEmpTel: string
  CompetenceSkillCode: string = ""
  selectedSkillLevel: string = ""
  errorMessage: string = '';
  IsShowAddEmpSkill: boolean = false;

  isOnUpdate: boolean;
  isSubmitted: any;

  externalType: string = '2';
  internalType: string = '1';

  //Pagination variable
  public currentPageNumber: number
  public EmpTotal: any
  public totalPages: number
  public environment: number

  element: HTMLElement;
  public hidcouchk: string;
  baseurl: string;

  _ForK2: string;
  _EmpCode: string;

  getTokenUrl: string;

  //Modal
  titlemodal: string;
  detailmodal: string;

  constructor(private httpClient: HttpClient, @Inject('BASE_URL') baseUrl: string, private activatedRoute: ActivatedRoute, private TokenService: TokenService, private GlobalService: GlobalService) {
    this.baseurl = environment.base_api;

    this._ForK2 = this.activatedRoute.snapshot.params.ForK2;
    this._EmpCode = this.activatedRoute.snapshot.params.EmpCode;
    GlobalService.CheckPagingAccessRights();
  }


  async ngOnInit() {
    
    $(document).ready(function () {
      $('#InsertSectionEmp').css('display', 'none'); 
    });
    
    this.currentPageNumber = 1;
    this.environment = environment.PageSize;

    this.loadDdlTitle()
    this.LoadEmp()
    this.loadDdlPosition()
    this.loadDdlEmpType()
    this.loadDdlTeam()
    this.loadDdlRole()
    this.loadDdlSubRole();
    this.loadddlCompany()
    this.loadGenderList();
    this.loadBaseAreaList();
    this.loadJobList();
    this.hidTitleCode = null
    this.hidPositionCode = 0
    this.hidEmpType = null
    this.hidTeamCode = null
    this.hidRoleCode = null
    this.birthDate = ""
    this.entryDate = ""
    this.resignDate = null

    this.loadCompetenceSkillList();
    this.loadSkillLevelList();

    this.LoadEmp();
  }
  ///////////////////////////////////////Events////////////////////////////////////////////
  btnClick_showEmpList() {
    this.isSearchSubmitted = true;
    this.LoadEmp()
  }

  btnClick_onInsertEmp() {
    this.birthDate = ""
    this.entryDate = ""
    this.resignDate = ""
    this.clearInsertSection();
    $('#InsertSectionEmp').css('display', 'block'); 
    this.isOnUpdate = false
  }

  btnClick_onUpdateEmp(id) {
    $('#InsertSectionEmp').css('display', 'block');
    document.getElementById("AddEditEmployee").scrollIntoView(); 
    this.isOnUpdate = true
  

    let index = this.empList.findIndex(x => x.Id == id);
    this.hidEmpId = this.empList[index].Id
    
    //Company Info
    this.ddlCompany = this.empList[index].CompanyCode != null ? this.empList[index].CompanyCode : null
    this.hidEmpType = this.empList[index].EmpType != null ? this.empList[index].EmpType : null
    this.txtEmpCode = this.empList[index].EmpCode
    this.txtExEmpCode = this.empList[index].EmpCode

    var d = new Date(this.empList[index].EntryDate);
    this.entryDate = d.toLocaleDateString('en-CA');

    this.resignDate = this.empList[index].ResignDate === null ? null : new Date(this.empList[index].ResignDate).toISOString().substring(0, 10)

    //Personal Info
    this.hidTitleCode = this.empList[index].Title_EN != null ? this.empList[index].Title_EN : null
    this.txtEmpNickName_TH = this.empList[index].NickName
    this.txtEmpFName_TH = this.empList[index].EmpFname_TH
    this.txtEmpLName_TH = this.empList[index].EmpLname_TH
    this.txtEmpFName_EN = this.empList[index].EmpFname_EN
    this.txtEmpLName_EN = this.empList[index].EmpLname_EN
    //this.birthDate = new Date(this.empList[index].BirthDate).toLocaleDateString('en-CA');
    this.birthDate = this.empList[index].BirthDate === null ? null: new Date(this.empList[index].BirthDate).toISOString().substring(0, 10)
    this.ddlEmpGender = !!this.empList[index].Gender ? this.empList[index].Gender.toString() : "";
    this.ddlBaseArea = !!this.empList[index].BaseArea ? this.empList[index].BaseArea.toString() : "";
    this.ddlJobTitle = !!this.empList[index].JobCode ? this.empList[index].JobCode.toString() : "";
    this.ddlSubRole = !!this.empList[index].SubRoleLookupCode ? this.empList[index].SubRoleLookupCode.toString() : "";

    this.txtEmpEmail = this.empList[index].Mail;
    this.txtEmpTel = this.empList[index].Mobile;
    
    //Role/Position
    this.hidRoleCode = this.empList[index].RoleCode != null ? this.empList[index].RoleCode : null
    this.hidTeamCode = this.empList[index].TeamCode != null ? this.empList[index].TeamCode : null
    this.hidPositionCode = this.empList[index].PositionCode != null ? Number(this.empList[index].PositionCode) : null
    
    this.ClearEmpCompetenceSkill();
    this.LoadSelectedEmpCompetenceSkillList();
  }

  async btnClick_deleteEmp(id) {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };
      let strjsonCusInfo = "{EmpCode: " + id + "}";

      if (confirm("Are you sure you want to delete this employee?")) {
        this.isSubmitted = this.httpClient.post<EmpInfo[]>(this.baseurl + "Employee/DeleteEmployeeList", strjsonCusInfo, httpOptions)
          .subscribe(result => this.isSubmitted = result, failCb => {
            console.log("Update fail")
          },
            () => {
              console.log("Update = " + this.isSubmitted)
              this.clearInsertSection()

              //Inform user
              this.titlemodal = '';
              this.detailmodal = 'Employee information has been deleted successfully.';
              $('#ModalComplate .modal-header').text('Information');
              $('#ModalComplate .modal-header').addClass('bg-gold');
              $('#ModalComplate').modal();

              this.LoadEmp()
            }
          )
      }
    }

  }

  async btnClick_submitInsertEmp() {
    
    $('#InsertSectionEmp').css('display', 'block'); 
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      this.txtExEmpCode = this.EmpTotal + 1;
      if (this.txtEmpCode == null || this.txtEmpCode == '') {

        let objData = {};
        objData["CompanyCode"] = this.ddlCompany;
        objData["EmpType"] = this.hidEmpType;
        objData["EmpCode"] = this.ddlCompany + "0" + this.txtExEmpCode;
        objData["EntryDate"] = this.entryDate;
        objData["ResignDate"] = this.resignDate;

        objData["Title_TH"] = this.hidTitleCode;
        objData["Title_EN"] = this.hidTitleCode;
        objData["NickName"] = this.txtEmpNickName_TH;
        objData["EmpFname_TH"] = this.txtEmpFName_TH;
        objData["EmpLname_TH"] = this.txtEmpLName_TH;
        objData["EmpFname_EN"] = this.txtEmpFName_EN;
        objData["EmpLname_EN"] = this.txtEmpLName_EN;
        objData["BirthDate"] = this.birthDate;
        objData["Mail"] = this.txtEmpEmail;
        objData["Mobile"] = this.txtEmpTel;
        objData["Gender"] = !!this.ddlEmpGender ? this.ddlEmpGender : $('#ddlEmpGender').val();
        objData["BaseArea"] = !!this.ddlBaseArea ? this.ddlBaseArea : $('#ddlBaseArea').val();
        objData["JobTitle"] = !!this.ddlJobTitle ? this.ddlJobTitle : $('#ddlJobTitle').val();
        objData["SubRoleLookupCode"] = !!this.ddlSubRole ? this.ddlSubRole : $('#ddlSubRole').val();

        objData["RoleCode"] = this.hidRoleCode;
        objData["PositionCode"] = this.hidPositionCode;
        objData["TeamCode"] = this.hidTeamCode;

        objData["FlagDelete"] = "N";

        let strjson = JSON.stringify(objData);

        this.isSubmitted = this.httpClient.post<EmpInfo[]>(this.baseurl + "Employee/InsertEmployee", strjson, httpOptions)

          .subscribe(result => this.isSubmitted = result, failCb => {
            console.log("Insert fail")
          },
            () => {
              console.log("Insert = " + this.isSubmitted)
              this.clearInsertSection()
              $('#InsertSectionEmp').css('display', 'none'); 
              //this.AuthorizeUser(this.ddlCompany + "0" + this.txtExEmpCode);

              //Inform user
              this.titlemodal = '';
              this.detailmodal = 'User information has been created successfully.';
              $('#ModalComplate .modal-header').text('Information');
              $('#ModalComplate .modal-header').addClass('bg-gold');
              $('#ModalComplate').modal();

              this.LoadEmp()
            }
          )
      }
      else {

        let objData = {};
        objData["CompanyCode"] = this.ddlCompany;
        objData["EmpType"] = this.hidEmpType;
        objData["EmpCode"] = this.txtEmpCode;
        objData["EntryDate"] = this.entryDate;
        objData["ResignDate"] = this.resignDate;

        objData["Title_TH"] = this.hidTitleCode;
        objData["Title_EN"] = this.hidTitleCode;
        objData["NickName"] = this.txtEmpNickName_TH;
        objData["EmpFname_TH"] = this.txtEmpFName_TH;
        objData["EmpLname_TH"] = this.txtEmpLName_TH;
        objData["EmpFname_EN"] = this.txtEmpFName_EN;
        objData["EmpLname_EN"] = this.txtEmpLName_EN;
        objData["BirthDate"] = this.birthDate;
        objData["Mail"] = this.txtEmpEmail;
        objData["Mobile"] = this.txtEmpTel;
        objData["Gender"] = !!this.ddlEmpGender ? this.ddlEmpGender : $('#ddlEmpGender').val();
        objData["BaseArea"] = !!this.ddlBaseArea ? this.ddlBaseArea : $('#ddlBaseArea').val();
        objData["JobTitle"] = !!this.ddlJobTitle ? this.ddlJobTitle : $('#ddlJobTitle').val();
        objData["SubRoleLookupCode"] = !!this.ddlSubRole ? this.ddlSubRole : $('#ddlSubRole').val();

        objData["RoleCode"] = this.hidRoleCode;
        objData["PositionCode"] = this.hidPositionCode;
        objData["TeamCode"] = this.hidTeamCode;

        objData["FlagDelete"] = "N";

        
        let strjson = JSON.stringify(objData);

        this.isSubmitted = this.httpClient.post<EmpInfo[]>(this.baseurl + "Employee/InsertEmployee", strjson, httpOptions)

          .subscribe(result => this.isSubmitted = result, failCb => {
            console.log("Insert fail")
          },
            () => {
              console.log("Insert = " + this.isSubmitted)
              this.clearInsertSection()
              
              $('#InsertSectionEmp').css('display', 'none'); 
              //this.AuthorizeUser(this.txtEmpCode);

              this.LoadEmp()
            }
          )
      }
    }

  }

  
  btnClick_submitUpdateEmp(id) {
    $('#ModalConfirmChanges').modal();
  }

  async confirmSaveChanges() {
    $('#ModalConfirmChanges').modal('hide');
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      
      $('#InsertSectionEmp').css('display', 'block'); 
      var id = this.hidEmpId
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };


      if (this.txtEmpCode == undefined || this.txtEmpCode == null || this.txtEmpCode == '') {
        alert("กรุณากรอกข้อมูลให้ครบถ้วน");
      }
      else {
        await this.SaveEmpSkill();

        let objData = {};
        objData["EmpId"] = id;

        objData["CompanyCode"] = this.ddlCompany;
        objData["EmpType"] = this.hidEmpType;
        objData["EmpCode"] = this.txtEmpCode;
        objData["EntryDate"] = this.entryDate;
        objData["ResignDate"] = this.resignDate;

        objData["Title_TH"] = this.hidTitleCode;
        objData["Title_EN"] = this.hidTitleCode;
        objData["NickName"] = this.txtEmpNickName_TH;
        objData["EmpFname_TH"] = this.txtEmpFName_TH;
        objData["EmpLname_TH"] = this.txtEmpLName_TH;
        objData["EmpFname_EN"] = this.txtEmpFName_EN;
        objData["EmpLname_EN"] = this.txtEmpLName_EN;
        objData["BirthDate"] = this.birthDate;
        objData["Mail"] = this.txtEmpEmail;
        objData["Mobile"] = this.txtEmpTel;
        objData["Gender"] = !!this.ddlEmpGender ? this.ddlEmpGender : $('#ddlEmpGender').val();
        objData["BaseArea"] = !!this.ddlBaseArea ? this.ddlBaseArea : $('#ddlBaseArea').val();
        objData["JobTitle"] = !!this.ddlJobTitle ? this.ddlJobTitle : $('#ddlJobTitle').val();
        objData["SubRoleLookupCode"] = !!this.ddlSubRole ? this.ddlSubRole : $('#ddlSubRole').val();

        objData["RoleCode"] = this.hidRoleCode;
        objData["PositionCode"] = this.hidPositionCode;
        objData["TeamCode"] = this.hidTeamCode;

        objData["FlagDelete"] = "N";

        let strjson = JSON.stringify(objData);

        this.isSubmitted = this.httpClient.post<EmpInfo[]>(this.baseurl + "Employee/UpdateEmployee", strjson, httpOptions)

          .subscribe(result => this.isSubmitted = result, failCb => {
            console.log("Update fail")
          },
            () => {
              console.log("Update = " + this.isSubmitted)
              this.clearInsertSection()
              $('#InsertSectionEmp').css('display', 'none'); 

              //Inform user
              this.titlemodal = '';
              this.detailmodal = 'User information has been updated successfully.';
              $('#ModalComplate .modal-header').text('Information');
              $('#ModalComplate .modal-header').addClass('bg-gold');
              $('#ModalComplate').modal();

              //Load new data
              this.LoadEmp()
            }
          )
      }
    }
  }

  chkallclick() {
    for (var i = 0; i <= 100; i++) {
      this.element = document.getElementById('chk' + i) as HTMLElement;
      this.element.click();
    }
  }

  async btnClick_onDeleteEmp() {
    let num = parseInt(this.hidcouchk);
    for (var i = 0; i < num; i++) {
      var element = <HTMLInputElement>document.getElementById('chk' + i);
      var isChecked = element.checked;

      var element2 = <HTMLInputElement>document.getElementById('Id' + i);

      if (isChecked) {
        await this.btnClick_deleteEmp(parseInt(element2.value));
      }
    }
    this.LoadEmp();
  }

  btnClick_AuthorizeUser(EmpCode) {
    this.AuthorizeUser(EmpCode);
  }
  ///////////////////////////////////////Functions/////////////////////////////////////////

  LoadEmp() {
    this.LoadEmpList()
      .then(
        data => {
          this.empList = data
          this.hidcouchk = this.empList.length.toString();
        }
      )
      .then(() => {
        this.CountEmpList()
      })
  }

  async LoadEmpList(): Promise<EmpInfo[]> {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let offset = (this.currentPageNumber - 1) * environment.PageSize;
      
      var objectjson = {};
      objectjson['EmpCode'] = this.checkUndefinedString(this.txtSearchEmpCode);
      objectjson['EmpName_TH'] = this.checkUndefinedString(this.txtSearchEmpName_TH);
      objectjson['CompanyCode'] = this.checkUndefinedString(this.txtSearchCompany);
      objectjson['rowFetch'] = environment.PageSize;
      objectjson['rowOFFSet'] = offset;
      objectjson['FlagDelete'] = "N";

      let strjson = JSON.stringify(objectjson);

      console.log(strjson)

      this.EmpOnPromise = this.httpClient
        .post<EmpInfo[]>(this.baseurl + "Employee/GetEmployeeCriteria",
          strjson, httpOptions)
        .toPromise()

      return this.EmpOnPromise;
    }
  }

  async CountEmpList() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let offset = (this.currentPageNumber - 1) * environment.PageSize;


      let strjson = "{\"EmpCode\": \"" + this.checkUndefinedString(this.txtSearchEmpCode) + "\", " +
        "\"EmpName_TH\": \"" + this.checkUndefinedString(this.txtSearchEmpName_TH) + "\", " +
        "\"CompanyCode\": \"" + this.checkUndefinedString(this.txtSearchCompany) + "\", " +
        "\"FlagDelete\": \"N\"" +
        "}";


      this.httpClient
        .post<EmpInfo[]>(this.baseurl + "Employee/GetCountEmployeeCriteria",
          strjson, httpOptions)
        .toPromise().then(data => {
          this.EmpTotal = data
        })
        .then(() => {
          if (this.EmpTotal == 0) {
            this.currentPageNumber = 1;
          }
          this.totalPages = Math.ceil(this.EmpTotal / environment.PageSize)
        })
    }
  }

  async loadDdlTeam() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {

      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let strjson = "{\"TeamCode\":\"\" }";

      this.httpClient.post<TeamInfo[]>(this.baseurl + "Team/GetTeamCriteria", strjson, httpOptions)
        .toPromise().then((data) => {
          this.TeamList = data
        })
    }
  }

  async loadDdlRole() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let strjson = "{\"RoleCode\":\"\" }";

      this.httpClient.post<RoleInfo[]>(this.baseurl + "Role/GetRole", strjson, httpOptions)
        .toPromise().then((data) => {
          this.RoleList = data
        })
    }
  }

  async loadDdlSubRole() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };
      let strjson = "{\"LookupType\":\"EMPSUBROLE\" }";

      this.httpClient.post<LookupInfo[]>(this.baseurl + "Lookup/GetLookup", strjson, httpOptions)
        .toPromise().then((data) => {

          this.SubRoleList = data
        })
    }
  }

  async loadDdlPosition() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };
      var objjson = {};
      objjson['FlagActive'] = 'Y'
      let strjson = JSON.stringify(objjson);

      this.httpClient.post<PositionLevelInfo[]>(this.baseurl + "Position/GetPositionLevelList", strjson, httpOptions)
        .toPromise().then((data) => {
          this.PositionList = data
        })
    }
  }

  async loadDdlEmpType() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };
      let strjson = "{\"LookupType\":\"CONTACTLISTTYPE\" }";

      this.httpClient.post<LookupInfo[]>(this.baseurl + "Lookup/GetLookup", strjson, httpOptions)
        .toPromise().then((data) => {

          this.EmpTypeList = data
        })
    }
  }

  async loadDdlTitle() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let strjson = "{\"LookupType\":\"TITLE\" }";

      console.log(strjson);

      this.httpClient.post<LookupInfo[]>(this.baseurl + "Lookup/GetLookup", strjson, httpOptions)
        .toPromise().then((data) => {
          this.TitleList = data
        })
    }
  }

  async loadddlCompany() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let strjson = "{\"CompanyCustomerType\":\"55\" }";

      this.httpClient.post<CompanyInfo[]>(this.baseurl + "Company/GetCompany", strjson, httpOptions)
        .toPromise().then((data) => {
          this.CompanyList = data
        })
    }
  }

  async loadGenderList() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let strjson = "{\"LookupType\":\"GENDER\" }";

      console.log(strjson);

      this.httpClient.post<LookupInfo[]>(this.baseurl + "Lookup/GetLookup", strjson, httpOptions)
        .toPromise().then((data) => {
          this.GenderList = data
        })
    }
  }

  async loadJobList() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson['FLAG_ACTIVE'] = 'Y';

      let strjson = JSON.stringify(objectjson);

      console.log(strjson);

      this.httpClient.post<JobInfo[]>(this.baseurl + "Job/GetJob", strjson, httpOptions)
        .toPromise().then((data) => {
          this.JobTitleList = data
        })
    }
  }

  async loadBaseAreaList() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let strjson = "{\"LookupType\":\"BaseArea\" }";

      console.log(strjson);

      this.httpClient.post<LookupInfo[]>(this.baseurl + "Lookup/GetLookup", strjson, httpOptions)
        .toPromise().then((data) => {
          this.BaseAreaList = data
        })
    }
  }

  checkUndefinedString(strInput: string) {
    if (strInput === undefined || strInput === null) {
      strInput = ''
    }
    return strInput

  }

  clearInsertSection() {
    this.hidEmpId = null
    
    //Company Info
    this.ddlCompany = null;
    this.hidEmpType = null;
    this.txtEmpCode = "";
    this.txtExEmpCode = "";
    this.entryDate = null;
    this.resignDate = null;

    //Personal Info
    this.hidTitleCode = null
    this.txtEmpNickName_TH = ""
    this.txtEmpFName_TH = ""
    this.txtEmpLName_TH = ""
    this.txtEmpFName_EN = "";
    this.txtEmpLName_EN = "";
    this.ddlEmpGender = "";
    this.ddlBaseArea = "";
    this.ddlJobTitle = "";
    this.ddlSubRole = "";
    this.birthDate = null;
    this.txtEmpEmail = "";
    this.txtEmpTel = "";

    //Role/Position
    this.hidRoleCode = null;
    this.hidPositionCode = 0
    this.hidTeamCode = null
  }

  clearSearchSection() {

    this.txtSearchEmpCode = ""
    this.txtSearchEmpName_TH = ""
    this.txtSearchCompany = ""
    this.isSearchSubmitted = false;
    this.LoadEmp();
  }

  btnClick_cancel() {
    this.clearInsertSection();
    $('#InsertSectionEmp').css('display', 'none'); 
  }

  async UpdateEmpCode() {
    //Open both type can generate emp code
    //if (this.hidEmpType == this.internalType) {
      let empcode: string = await this.LoadLatestEmpCode().then(empcode => {
        return empcode.EmpCode;
      }).catch(err => {
        console.log(err);
        return "";
      });

      this.txtEmpCode = empcode;
    //}
  }

  async LoadLatestEmpCode(): Promise<any> {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson['CompanyCode'] = this.ddlCompany;
      let strjson = JSON.stringify(objectjson);

      return this.httpClient.post<any>(this.baseurl + "Employee/GetLatestEmployeeCode", strjson, httpOptions)
        .toPromise();
    }
   
  }

  //For Pagination
  LoadListPagination(traget) {
    this.currentPageNumber = traget.currentPageNumber;
    this.totalPages = traget.totalPages;
  }

  OnLoadListFinished(traget = null) {

    if (traget != null) { // check call function from change page or onloadfrist
      this.LoadListPagination(traget);
      this.LoadEmp();
    }

  }

  AuthorizeUser(txtEmpCode) {
    //Open new tab to do OAuth2
    this.getTokenUrl = this.TokenService.GetAccessTokenUrl(txtEmpCode);
    
    window.open(this.getTokenUrl, "_blank");

  }

  async loadCompetenceSkillList() {
      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth_token}`
          })
        };
  
        // Prepare search parameters
        var objectjson = {};
  
        console.log('objectjson', objectjson);
  
        try {
          const result = await this.httpClient.post<CompetenceSkillInfo[]>(this.baseurl + "CompetenceSkill/GetCompetenceSkill", objectjson,
          httpOptions).toPromise();
  
          this.CompetenceSkillList = result;

          if (this.CompetenceSkillList.length > 0) {
            this.CompetenceSkillCode = null;
          }
          //console.log('CompetenceSkillList', this.CompetenceSkillList);
          // this.processData();
        } catch (error) {
          console.error('API Error:', error);
        }
        
      }
  }

  async loadSkillLevelList() {
      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth_token}`
          })
        };
  
        // Prepare search parameters
        var objectjson = {};

        objectjson['LookupType'] = "SkillLevel";
  
        console.log('objectjson', objectjson);
  
        try {
          const result = await this.httpClient.post<LookupInfo[]>(this.baseurl + "Lookup/GetLookup", objectjson,
          httpOptions).toPromise();
  
          this.SkillLevelList = result;

          if (this.SkillLevelList.length > 0) {
            this.selectedSkillLevel = this.SkillLevelList[0].LookupCode;
          }
          //console.log('SkillLevelList', this.SkillLevelList);
          // this.processData();
        } catch (error) {
          console.error('API Error:', error);
        }
        
      }
  }

  onCompetenceSkillChange(event: Event) {
    const selectedElement = event.target as HTMLSelectElement;
    const selectedValue = selectedElement.value;
    //console.log('Selected Value:', selectedValue);


    const selectedOptionIndex = selectedElement.selectedIndex;
    const selectedOptionText = selectedElement.options[selectedOptionIndex].text;
    //console.log('Selected Name:', selectedOptionText);
  }

  AddEmpCompetenceSkill() {
    if (!this.CompetenceSkillCode) {
      this.errorMessage = 'กรุณาเลือก Competence Skill ก่อน';
      return;
    }

    this.errorMessage = '';
    //console.log('CompetenceSkillCode', this.CompetenceSkillCode);
    const skillName = this.CompetenceSkillList.find(item => item.CompetenceSkillCode === this.CompetenceSkillCode)?.CompetenceSkillName;
    //console.log('CompetenceSkillName', skillName);

    //console.log('selectedSkillLevel', this.selectedSkillLevel);

    const selectedSkillValue = this.SkillLevelList.find(item => item.LookupCode === this.selectedSkillLevel)?.LookupValue;
    //console.log('LookupValue', selectedSkillValue);

    //console.log('EmpIdFocus', this.hidEmpId);
    const empCode = this.empList.find(emp => emp.Id === this.hidEmpId)?.EmpCode;
    //console.log('EmpCode', empCode);

    const newCompetenceSkill = {
    EmployeeCompetenceSkillID: 0, // intit value number
    EmpCode: empCode || '',
    EmpName: '',
    CompetenceSkillCode: this.CompetenceSkillCode,
    CompetenceSkillName: skillName || '',
    SkillLevelCode: this.selectedSkillLevel,
    SkillLevelName: selectedSkillValue || '',
    CreateDate: new Date().toISOString(), // use todate
    CreateBy: empCode,
    UpdateDate: '',
    UpdateBy: '',
    FlagDelete: 'N',
    rowFetch: 0,
    rowOFFSet: 0,
    itemTotal: 0
  };

  // push to SelectedEmpCompetenceSkillList
  this.SelectedEmpCompetenceSkillList.push(newCompetenceSkill);

  //console.log('Added Competence Skill:', newCompetenceSkill);
  console.log('SelectedEmpCompetenceSkillList', this.SelectedEmpCompetenceSkillList);
  }

  ClearEmpCompetenceSkill() {
    this.CompetenceSkillCode = null;
    this.selectedSkillLevel = "1"
    this.errorMessage = '';
    this.IsShowAddEmpSkill = false;
  }

  removeSelectedEmpCompetenceSkill(index: number) {
    if (index > -1 && index < this.SelectedEmpCompetenceSkillList.length) {
      this.SelectedEmpCompetenceSkillList.splice(index, 1);
    }
  }

  async LoadSelectedEmpCompetenceSkillList() {
    var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth_token}`
          })
        };
  
        const empCode = this.empList.find(emp => emp.Id === this.hidEmpId)?.EmpCode;
        // Prepare search parameters
        var objectjson = {};

        objectjson['EmpCode'] = empCode;
        console.log('objectjson', objectjson);
  
        try {
          const result = await this.httpClient.post<EmployeeCompetenceSkillInfo[]>(this.baseurl + "EmployeeCompetenceSkill/GetEmployeeCompetenceSkill", objectjson,
          httpOptions).toPromise();
  
          this.SelectedEmpCompetenceSkillList = result;
          //console.log('SelectedEmpCompetenceSkillList', this.SelectedEmpCompetenceSkillList);
          // this.processData();
        } catch (error) {
          console.error('API Error:', error);
        }
        
      }
  }

  onOpenEditEmpSkill() {
    this.IsShowAddEmpSkill = true;
  }

  async SaveEmpSkill() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const empCode = this.empList.find(emp => emp.Id === this.hidEmpId)?.EmpCode;
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let newCompetenceSkill: EmployeeCompetenceSkillInfo;
      if (this.SelectedEmpCompetenceSkillList.length === 0) {
          newCompetenceSkill = {
          EmployeeCompetenceSkillID: 0, // intit value number
          EmpCode: empCode || '',
          EmpName: '',
          CompetenceSkillCode: '',
          CompetenceSkillName: '',
          SkillLevelCode: '',
          SkillLevelName: '',
          CreateDate: '', // use todate
          CreateBy: '',
          UpdateDate: '',
          UpdateBy: '',
          FlagDelete: '',
          rowFetch: 0,
          rowOFFSet: 0,
          itemTotal: 0
        };
      
        this.SelectedEmpCompetenceSkillList.push(newCompetenceSkill);
      }

      const strjson = JSON.stringify(this.SelectedEmpCompetenceSkillList);
      try {
        const result = await this.httpClient.post<boolean>(this.baseurl + "EmployeeCompetenceSkill/InsertUpdateEmployeeCompetenceSkill", strjson, httpOptions)
        .toPromise();

        this.isSubmitted = result;       
          
      } catch (err) {
        console.error("Insert failed", err);
      } finally {
          //this.OnCreating('n');
      }
    }
  }

}
